import { render, staticRenderFns } from "./RobotPreview.vue?vue&type=template&id=465e67f9&scoped=true&"
import script from "./RobotPreview.vue?vue&type=script&lang=ts&"
export * from "./RobotPreview.vue?vue&type=script&lang=ts&"
import style0 from "./RobotPreview.vue?vue&type=style&index=0&id=465e67f9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465e67f9",
  null
  
)

export default component.exports